const evalForm = document.querySelector('.umbraco-forms-evaluationV3');

if (typeof(evalForm) != 'undefined' && evalForm != null) {

    const fieldsetToggleOnKeydown = (e) => {
        let key = event.key;

        switch (key) {
            case " ":
            case "Enter":
            case "Space":
                if(e.currentTarget.parentElement.hasAttribute('open')){
                    e.currentTarget.parentElement.removeAttribute('open' , '');
                }else{
                    e.currentTarget.parentElement.setAttribute('open', '');
                }
                break;

            default:
                break;
        }
    }

    const toggleFieldset = (e) => {
        if(e.currentTarget.parentElement.hasAttribute('open')){
            e.currentTarget.parentElement.removeAttribute('open' , '');
        }else{
            e.currentTarget.parentElement.setAttribute('open', '');
        }
    }

    const fieldsetAction = (e) => {
        //If Next Section Button is the current Target Event
        if(e.currentTarget.classList.contains('eval-next')){
            const dataCurrent = e.currentTarget.getAttribute('data-current');
            const dataNext = e.currentTarget.getAttribute('data-next');
            const evalFocusableElements = ['input' , 'button' , '[href]', 'select', 'textarea', '[tabindex]:not([tabindex="-1"])'];
            const currentFieldset = evalForm.querySelector('.umbraco-forms-fieldset[data-id="' + dataCurrent + '"]');
            const nextFieldset = evalForm.querySelector('.umbraco-forms-fieldset[data-id="' + dataNext + '"]');
            let firstFocusableEvalElement = nextFieldset.querySelectorAll(evalFocusableElements)[0];
            currentFieldset.removeAttribute('open');
            nextFieldset.setAttribute('open' , '');
            nextFieldset.scrollIntoView({
                behavior: "auto"
            });
            firstFocusableEvalElement.focus();
        } 
        //If Prev Section Button is the current Target Event
        else if(e.currentTarget.classList.contains('eval-prev')){
            const dataCurrent = e.currentTarget.getAttribute('data-current');
            const dataPrev = e.currentTarget.getAttribute('data-prev');
            const evalFocusableElements = ['input' , 'button' , '[href]', 'select', 'textarea', '[tabindex]:not([tabindex="-1"])'];
            const currentFieldset = evalForm.querySelector('.umbraco-forms-fieldset[data-id="' + dataCurrent + '"]');
            const prevFieldset = evalForm.querySelector('.umbraco-forms-fieldset[data-id="' + dataPrev + '"]');
            let firstFocusableEvalElement = prevFieldset.querySelectorAll(evalFocusableElements)[0];
            currentFieldset.removeAttribute('open');
            prevFieldset.setAttribute('open' , '');
            prevFieldset.scrollIntoView({
                behavior: "auto"
            });
            firstFocusableEvalElement.focus();
        }
    }

    const fieldsetActionButtons = evalForm.querySelectorAll('.evaluation__form__controls a');

    for (let i = 0; i < fieldsetActionButtons.length; i++) {
        fieldsetActionButtons[i].addEventListener('click', fieldsetAction, false);
    }

    const umbracoFieldsetHeaders = evalForm.querySelectorAll('.umbraco-forms-fieldset > header');

    for (let i = 0; i < umbracoFieldsetHeaders.length; i++) {
        umbracoFieldsetHeaders[i].setAttribute('tabindex', '0');
        umbracoFieldsetHeaders[i].parentElement.setAttribute('data-id' , i);

        const prevButton = umbracoFieldsetHeaders[i].parentElement.querySelector('.eval-prev');
        if (typeof(prevButton) != 'undefined' && prevButton != null) {
            prevButton.setAttribute('data-prev' , i - 1);
            prevButton.setAttribute('data-current' , i);
        }

        const nextButton = umbracoFieldsetHeaders[i].parentElement.querySelector('.eval-next');
        if (typeof(nextButton) != 'undefined' && nextButton != null) {
            nextButton.setAttribute('data-next' , i + 1);
            nextButton.setAttribute('data-current' , i);
        }

        umbracoFieldsetHeaders[i].addEventListener('click', toggleFieldset, false);
        umbracoFieldsetHeaders[i].addEventListener('keydown', fieldsetToggleOnKeydown, false);
    }

    evalForm.arrive('.field-validation-error', { fireOnAttributesModification: true, existing: true }, function() {
        this.closest('.umbraco-forms-fieldset').setAttribute('open', '');
    });
    
}